// ScrollToTop.js
import React, { useState, useEffect } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"; // Import icon from MUI
import "./ScrollToTop.css"; // CSS file for custom styling

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        const startPosition = window.pageYOffset;
        const duration = 600; // total duration of scroll animation in ms
        const startTime = performance.now();

        const animateScroll = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1); // cap progress at 1
            const easeInOutQuad = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress; // ease-in-out easing function

            window.scrollTo(0, startPosition * (1 - easeInOutQuad)); // calculate current position based on easing

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            }
        };

        requestAnimationFrame(animateScroll);
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <div className={`scroll-to-top ${isVisible ? "show" : ""}`} onClick={scrollToTop}>
            <ArrowUpwardIcon />
        </div>
    );
};

export default ScrollToTop;
